import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./CRRMemberSearchForm.scss";
import { Alert } from "@mui/material";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function CRRMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  // const [vehicleId, setVehicleId] = useState(props.vehicleId || "");
  // const [licensePlate, setLicensePlate] = useState(props.licensePlate || "");
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: "LAST8_VIN", value: t("ATF.ContractSearch.DropdownOptions3") },
    { key: "AGREEMENT_NUM", value: t("ATF.ContractSearch.DropdownOptions4") },
    // { key: "VEHICLE_ID", value: t("ATF.ContractSearch.DropdownOptions1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("LAST8_VIN");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");

  // useEffect(() => {
  //   devLog(selectedSearchTypes);
  //   // setVehicleId(vehicleId);
  //   // setLicensePlate(licensePlate);
  //   setMemberNumber(memberNumber);
  //   setLast8Vin(last8Vin);
  // }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        // vehicleId: vehicleId,
        // licensePlate: licensePlate,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        // vehicleId: vehicleId,
        // licensePlate: licensePlate,
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*Vehicle ID*/}
          {/* {selectedSearchTypes === "VEHICLE_ID" && (
            <>
              <div className="group-1">
                <div className="label">
                  {t("ATF.ContractSearch.DropdownOptions1")}:
                </div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions1")}
                  name="vehicleId"
                  className="input form-control required"
                  value={vehicleId}
                  onChange={(e) => {
                    setVehicleId(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )} */}

          {/*Agreement Number*/}
          {selectedSearchTypes === "AGREEMENT_NUM" && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions4")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions4")}
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/* <div className="vin-title">
            {t("ATF.ContractSearch.DropdownOptions3")}
          </div>

          {/*Last 8 VIN*/}
          {selectedSearchTypes === "LAST8_VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("ATF.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  placeholder={t("ATF.ContractSearch.DropdownOptions3")}
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  onChange={(e) => {
                    setMoreThanEightVin(false);
                    vinInputLength(e);
                    setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
              {moreThanEightVin && <Alert severity="error">{t("description.VinInputErrorMsg")}</Alert>}
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default CRRMemberSearchForm;
